import CsmGenericSelectField, { ICsmGenericSelectFieldProps } from '../select/CsmGenericSelectField';

type ThreeWayValueType = 1 | 2 | 3;

export interface ICsmThreeWaySelectFieldProps extends Omit<ICsmGenericSelectFieldProps<ThreeWayValueType, ThreeWayValueType>,
    "value" | "list" | "valueGetter" | "labelGetter" | "onChange" | "isAutoComplete"> {
    value: boolean | null
    onChange: (e: boolean | null) => void,
    trueText: string,
    falseText: string,
    emptyText: string,
}

export default function CsmThreeWaySelectField(props: ICsmThreeWaySelectFieldProps) {
    const { value, onChange, trueText, falseText, emptyText, ...rest } = props;

    const list: ThreeWayValueType[] = [1, 2, 3];

    const convertBoolToTWT = (value: boolean | null): ThreeWayValueType => {
        return value === null ? 1 : value === true ? 2 : 3;
    }

    const convertTWTToBool = (value: ThreeWayValueType | null): boolean | null => {
        if (value === null) return null;
        else
            return value === 1 ? null : value === 2 ? true : false;
    }

    const convertTWTToLabel = (value: ThreeWayValueType | null): string => {
        return (value === null || value === 1) ? emptyText : value === 2 ? trueText : falseText;
    }

    return <CsmGenericSelectField
        value={convertBoolToTWT(value)}
        list={list}
        labelGetter={e => convertTWTToLabel(e)}
        valueGetter={e => e}
        onChange={e => onChange(convertTWTToBool(e))}
        {...rest}
    />;
}
